import { Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import FormData from "./BrandsForm";
import useAuth from "../../../hooks/useAuth";
import usePermissions from "../../../hooks/permissions";
import { useEffect } from "react";
import { SideBarIds } from "../../../utils/constants";
import { showWarning } from "../../../helpers/toast";

const BrandForm = () => {
  const user = useAuth();
  const navigate = useNavigate();
  const permissions = usePermissions();

  const url = window.location.pathname;
  const path = url.includes("add");

  useEffect(() => {
    if (user?.role !== 1) {
      if (permissions) {
        let idx = -1;
        idx = permissions?.findIndex(
          (ele) => ele?.module?.id === SideBarIds.brands
        );
        if (idx > -1) {
          if (!permissions[idx]?.is_add || !permissions[idx]?.is_edit) {
            showWarning("You are not authorized to access this page");
            navigate(-1);
          }
        }
        showWarning("You are not authorized to access this page");
        navigate(-1);
        console.log(idx);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions, user]);

  return (
    <div className="module-container">
      <Card>
        <div className="detail-module-card">
          <h2>{!path ? "Edit " : "Add "}Brand</h2>
          <Button
            className="back-btn-container"
            type="primary"
            onClick={() => {
              navigate("/manage-brands", { replace: true });
            }}
          >
            Back
          </Button>
        </div>
        <FormData path={!path} />
      </Card>
    </div>
  );
};

export default BrandForm;
